module.exports = __webpack_public_path__ + "static/media/bg-cover.174d3578.png";